import { Component, Input, ViewChild } from '@angular/core';

import { NceService } from '../../../nce/services/nce.service';
import { NceAdminService } from '../../../nce-admin/services/nce-admin.service';
import { PageNavigationService } from '../../services/page-navigation.service';
import { LayoutService } from '../../services/layout.service';
import { StorageService } from '../../services/storage.service';
import { FileService } from '../../services/file.service';
import { ErrorService } from '../../services/error.service';
import { PopupService } from '../../services/pop-up.service';

import { CONFIGURATION } from '../../configuration/configuration';
import { STATIC_VALUE } from '../../configuration/static.value';
import { API_ENDPOINTS } from '../../configuration/api-endpoints';

@Component({
    selector: 'preview-child',
    templateUrl: 'preview-child.component.html',
})
export class PreviewChildComponent{

	vCurrentAccor: number;
    vExpandStatus = [false, false, false, false, false, false, false, false, false, false, false];
    currFile: number;
    isEditMode: boolean = false;
    remarks: string = '';
    cancelationRemarks: string = '';
    nceRejectionRemarks: string = '';
    waitDiversionRemarks: string = '';

    @Input()
    nceid: string = "";

    @ViewChild('fileInput') vFileInput;
    @ViewChild('fileInputAppointment') vFileAppointment;
    @ViewChild('fileInputCancellation') vFileCancellation;
    @ViewChild('fileInputNCERejection') vFileNCERejection;    

    vShow = {
        btn_back: false,
        btn_home: false,
        btn_payment: false,
        btn_briefing_session: false,
        btn_make_appointment: false,
        btn_approve: false,
        btn_cancel_nce: false,
        btn_reject: false,
        btn_waiting_diversion: false,
        btn_change_appointment: false,
        btn_special_reject: false,
        contractor_details: false,
        upload_document: false,
        briefing_session: false,
        appointment: false,
        reject: false,
        diversion: false,
        approval: false,
        btn_upload_appointment_upload: false,
        btn_upload_confirm_appointment: false,
        btn_upload_apply_for_final_approval_upload: false,
        payment: false,
        cancelled_attachment: false,
        apply_for_final_approval_upload: false
    }

    vLoadingShow: boolean = false;
    
    vAppointmentData = {
        updated_date: new Date(),
        appointment_date: new Date(),
        appointment_time: '',
        appointment_description: '',
        appointment_type: '',
        popup_title: ''
    }


    constructor(
        private _nceService: NceService,
        private _nceAdminService: NceAdminService,
        private _layoutService: LayoutService,
        private _pageNavigationService: PageNavigationService,
        private _storageService: StorageService,
        private _fileService: FileService,
        private _errorService: ErrorService,
        private _popupService: PopupService
    ) { }

    getExpandStatus(){
        return this.vExpandStatus
    }

    isExtensionNCE(){
        return this._layoutService.isExtensionNCE();
    }

    getMultipleFilesList(){
        return this._fileService.getMultipleFilesList();
    }

    getNceAttachment(){
        return this.getDetailNCE().attachment;
    }

    isAbleDeleteFile(pIndex: number){
        return (this.getFileList()[pIndex] !== '' && this.getFileList()[pIndex] !== undefined && this.getFileList()[pIndex] !== null);
    }

    removeMultipleAttachment(pIndex){
        if(this.getNceAttachment().plantmap.length <= 1){
            this._popupService.openGeneralConfirmationPopup('Error', 'NCE Application required at least 1 attachment', '', false, false);
        }else{
            this._fileService.deleteFiles(this.getDetailNCE().nce_request_id, 'nce', 'plantmap' , this.getNceAttachment().plantmap[pIndex]).then(
                (resolve) => {
                    this.getNceAttachment().plantmap.splice(pIndex, 1)
                    this._storageService.setSessionItem('nceMultipleFiles', JSON.stringify(this._fileService.getMultipleFilesList()));
                }, 
                (reject) => {
                    this._popupService.openGeneralConfirmationPopup('Error', 'Delete file unsuccessful, please try again', '', false, false);
                }
            );
        }
    }

    removeNewMultipleAttachment(pIndex){
        if(this.getNceAttachment().newplantmap.length <= 1){
            this._popupService.openGeneralConfirmationPopup('Error', 'NCE Application required at least 1 attachment', '', false, false);
        }else{
            this._fileService.deleteFiles(this.getDetailNCE().nce_request_id, 'nce', 'newplantmap' , this.getNceAttachment().newplantmap[pIndex]).then(
                (resolve) => {
                    this.getNceAttachment().newplantmap.splice(pIndex, 1)
                    this._storageService.setSessionItem('nceNewMultipleFiles', JSON.stringify(this._fileService.getNewMultipleFilesList()));
                }, 
                (reject) => {
                    this._popupService.openGeneralConfirmationPopup('Error', 'Delete file unsuccessful, please try again', '', false, false);
                }
            );
        }
    }

    removeAppointmentAttachment(pIndex, pFileName){
        if(this.getNceAttachment().appointment.length <= 1){
            this._popupService.openGeneralConfirmationPopup('Error', 'NCE Application required at least 1 attachment', '', false, false);
        }else{
            this.currFile = pIndex;
            this._fileService.deleteFiles(this.getDetailNCE().nce_request_id, 'nce', 'appointment' , pFileName).then(
                (resolve) => {
                    this.getNceAttachment().appointment.splice(pIndex, 1);
                    this._popupService.openGeneralConfirmationPopup('Notice', 'File successfully deleted', '', false, false);
                    this._storageService.setSessionItem('nceFiles', JSON.stringify(this._fileService.getFileLists()));
                },
                (reject) => {
                    this._popupService.openGeneralConfirmationPopup('Notice', 'Error delete file, please try again', '', false, false);
                }
            );
        }
    }

    fileEventMultiple(fileInput: any){
        let file = fileInput.target.files[0];
        if(file === undefined){
            return;
        }
        if(file.size > CONFIGURATION.FILE.MAX_SIZE || (file.type !== "image/jpeg" && file.type !== "application/pdf")) {
            this._popupService.openGeneralConfirmationPopup('Notice', 'Attached file type must be PDF or JPEG file only and up to 10MB', '', false, false);
            return;
        }

        if(this.getNceAttachment().plantmap !== undefined){
            if(this.getNceAttachment().plantmap.some(x => x === file.name)){
                this._popupService.openGeneralConfirmationPopup('Notice', 'Please provide file with another name', '', false, false);
                return;
            }
            this.getNceAttachment().plantmap.push(file.name);
            this._fileService.getSignedRequest(file, 'nce', 'plantmap', this.getDetailNCE().nce_request_id, this.getDetailNCE().nce_record_id);
            this.vFileInput.nativeElement.value = "";
        }else{
            this._fileService.getSignedRequest(file, 'nce', 'plantmap', this.getDetailNCE().nce_request_id, this.getDetailNCE().nce_record_id);
        }
    }

    fileEventNewMultiple(fileInput: any){
        let file = fileInput.target.files[0];
        if(file === undefined){
            return;
        }
        if(file.size > CONFIGURATION.FILE.MAX_SIZE || (file.type !== "image/jpeg" && file.type !== "application/pdf")) {
            this._popupService.openGeneralConfirmationPopup('Notice', 'Attached file type must be PDF or JPEG file only and up to 10MB', '', false, false);
            return;
        }

        if(this.getNceAttachment().newplantmap !== undefined){
            if(this.getNceAttachment().newplantmap.some(x => x === file.name)){
                this._popupService.openGeneralConfirmationPopup('Notice', 'Please provide file with another name', '', false, false);
                return;
            }
            this.getNceAttachment().newplantmap.push(file.name);
            this._fileService.getSignedRequest(file, 'nce', 'newplantmap', this.getDetailNCE().nce_request_id, this.getDetailNCE().nce_record_id);
            this.vFileInput.nativeElement.value = "";
        }else{
            this._fileService.getSignedRequest(file, 'nce', 'newplantmap', this.getDetailNCE().nce_request_id, this.getDetailNCE().nce_record_id);
        }
    }

    fileEventUpload(fileInput: any, type: string){
        let file = fileInput.target.files[0];
        if(file.size > CONFIGURATION.FILE.MAX_SIZE || (file.type !== "image/jpeg" && file.type !== "application/pdf")) {
            this._popupService.openGeneralConfirmationPopup('Error', 'Attached file type must be PDF or JPEG file only and up to 10MB', '', false, false);
        }
        else if(file !== undefined){
            if(type === 'sketch'){
                this.overwriteFile(file, type, 0);
            } else if (type === 'schedule'){
                this.overwriteFile(file, type, 1);
            } else if (type === 'support'){
                this.overwriteFile(file, type, 2);
            }
        }
    }

    overwriteFile(file, type, pIndex){
        if(this.getNceAttachment()[type] !== undefined && this.getNceAttachment()[type] !== '' && this.getNceAttachment()[type] !== null){
            let prevFileName = this.getNceAttachment()[type];
            this._fileService.deleteFiles(this.getDetailNCE().nce_request_id, 'nce', type , prevFileName).then(
                (resolve) => {
                    this.getNceAttachment()[type] = file.name;
                    this._fileService.getSignedRequest(file, 'nce', type, this.getDetailNCE().nce_request_id, this.getDetailNCE().nce_record_id);
                },
                (reject) => {
                    this._popupService.openGeneralConfirmationPopup('Error', 'Upload unsuccessful, please try again', '', false, false);
                    this.getNceAttachment()[type] = prevFileName;
                }
            );
        }else{
            this.getNceAttachment()[type] = file.name;
            this._fileService.getSignedRequest(file, 'nce', type, this.getDetailNCE().nce_request_id, this.getDetailNCE().nce_record_id);
        }
    }
    
    fileEventAppointment(fileInputAppointment: any){
        let file = fileInputAppointment.target.files[0];
        if(file === undefined){
            return;
        }
        if(file.size > CONFIGURATION.FILE.MAX_SIZE || (file.type !== "image/jpeg" && file.type !== "application/pdf")) {
            this._popupService.openGeneralConfirmationPopup('Notice', 'Attached file type must be PDF or JPEG file only and up to 10MB', '', false, false);
            return;
        }
        if(this.getNceAttachment().appointment !== undefined){
            if(this.getNceAttachment().appointment.some(x => x === file.name)){
                this._popupService.openGeneralConfirmationPopup('Notice', 'Please provide file with another name', '', false, false);
                return;
            }
            this.getNceAttachment().appointment.push(file.name);
            this._fileService.getSignedRequest(file, 'nce', 'appointment', this.getDetailNCE().nce_request_id, this.getDetailNCE().nce_record_id);
            this.vFileAppointment.nativeElement.value = "";
        }else{
            this._fileService.getSignedRequest(file, 'nce', 'appointment', this.getDetailNCE().nce_request_id, this.getDetailNCE().nce_record_id);
        }
    }

    fileEventCancellation(fileInputAppointment: any){
        let file = fileInputAppointment.target.files[0];
        if(file === undefined){
            return;
        }
        if(file.size > CONFIGURATION.FILE.MAX_SIZE || (file.type !== "image/jpeg" && file.type !== "application/pdf")) {
            this._popupService.openGeneralConfirmationPopup('Notice', 'Attached file type must be PDF or JPEG file only and up to 10MB', '', false, false);
            return;
        }
        if(this.getNceAttachment().appointment !== undefined){
            if(this.getNceAttachment().appointment.some(x => x === file.name)){
                this._popupService.openGeneralConfirmationPopup('Notice', 'Please provide file with another name', '', false, false);
                return;
            }
            this.getNceAttachment().appointment.push(file.name);
            this._fileService.getSignedRequest(file, 'nce', 'appointment', this.getDetailNCE().nce_request_id, this.getDetailNCE().nce_record_id);
            this.vFileAppointment.nativeElement.value = "";
        }else{
            this._fileService.getSignedRequest(file, 'nce', 'appointment', this.getDetailNCE().nce_request_id, this.getDetailNCE().nce_record_id);
        }
    }

    editMode(){
        this.isEditMode = true;
    }

    changeExpandedStatus(pIndex) {
        this.vCurrentAccor = pIndex;
        this.getExpandStatus()[pIndex] = !this.getExpandStatus()[pIndex];
    }

    resetShowState(){
        this.vShow = {
            btn_back: false,
            btn_home: false,
            btn_payment: false,
            btn_briefing_session: false,
            btn_make_appointment: false,
            btn_approve: false,
            btn_reject: false,
            btn_waiting_diversion: false,
            btn_change_appointment: false,
            btn_cancel_nce: false,
            btn_special_reject: false,
            contractor_details: false,
            upload_document: false,
            briefing_session: false,
            appointment: false,
            reject: false,
            diversion: false,
            approval: false,
            btn_upload_appointment_upload: false,
            btn_upload_confirm_appointment: false,
            btn_upload_apply_for_final_approval_upload: false,
            payment: false,
            cancelled_attachment: false,
            apply_for_final_approval_upload: false
        }
    }

    isLastStage() {
        function pad(n:number) {return n < 10 ? "0"+n : n;}
        let last_status_change_date = new Date(this.getDetailNCE().last_status_change_date);
        if(
            this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED || 
            this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPROVED || 
            this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.CANCELLED || 
            this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.EXPIRED || 
            this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPLICATION_EXPIRED
        ) return {
            indicator: true,
            value: pad(last_status_change_date.getDate())+"/"+pad(last_status_change_date.getMonth()+1)+"/"+last_status_change_date.getFullYear()
        };
        else return {
            indicator: false,
            value: null,
        };
    }

    getDetailNCE(){
        return this._nceService.vDetailNCE;        
    }

    getFileList(){
        return this._fileService.getFileLists();
    }

    isLoading(){
        return this._nceService.isLoading() || this._nceAdminService.isLoading() || this._fileService.isLoading();
    }

    checkFinalApproval() {
        // Have gone through Final Approval Application
        if(this.getDetailNCE().apply_for_final_approval_dates_1_completed) {
            this.openStatusConfirmationPopup(this.getAllNCEStatus().PENDING_FINAL, 'finalApprovalApplication', 'pending final');
        } else {
            this.openStatusConfirmationPopup(this.getAllNCEStatus().APPLY_FINAL_APPROVAL, 'appointmentConfirmation', 'final approval application')
        }
    }

    getNCEAppointmentHistory(appointmentType) {
        let appointmentArray = this.getDetailNCE().appointmentHistory ? this.getDetailNCE().appointmentHistory.filter(element => {
            return element.appointment_type == appointmentType;
        }) : [];
        
        if(appointmentArray) {
            appointmentArray.sort((a,b) => {
                if(a.updated_count > b.updated_count) return 1;
                else if(b.updated_count > a.updated_count) return -1;
                else 0;
            });
            let result = [];
            appointmentArray.forEach((element, index) => {
                let nextDate = '', nextDesc = '';
                if(index+1 == appointmentArray.length) {
                    nextDate = this.getDetailNCE().appointment_date;
                    nextDesc = this.getDetailNCE().appointment_description;
                } else {
                    nextDate = appointmentArray[index+1].appointment_date;
                    nextDesc = appointmentArray[index+1].appointment_description;
                }
                result.push(
                    "Changes #" + (result.length+1) + ") " + 
                    element.appointment_date + " " + element.appointment_description + " to " +
                    nextDate + " " + nextDesc +
                    ", updated on " + element.updated_date
                );
            });
            appointmentArray = result;
        }
        return appointmentArray;
    }

    isShowState(){
        let access;
        this.resetShowState();
        try{
            access = JSON.parse(this._storageService.getLocalItem('access'));
        }catch(e){
            access = null;
        }
        this.vShow.contractor_details = true;
        if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_PROVISIONING ||
            this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_SCHEDULE || 
            this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_DOCUMENT ||
            this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPOINTMENT_DOCUMENT_UPLOAD || 
            this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED_APPOINTMENT_DOCUMENT){
            this.vShow.briefing_session = true;
        } else if(this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_TRIAL_HOLE_INSPECTION){
            this.vShow.briefing_session = true;
            this.vShow.appointment = true;
            this.vShow.apply_for_final_approval_upload = true
        } else if(this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED){
            this.vShow.briefing_session = true;
            this.vShow.appointment = true;
            this.vShow.reject = true;
            this.vShow.apply_for_final_approval_upload = true
            if(this.getDetailNCE().attachment.waiting_for_diversion !== undefined){
                this.vShow.diversion = true;
            }
        } else if(this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.WAIT_DIVERSION){
            this.vShow.briefing_session = true;
            this.vShow.appointment = true;
            this.vShow.diversion = true;
            this.vShow.apply_for_final_approval_upload = true
        } else if(this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPROVED){
            this.vShow.briefing_session = true;
            this.vShow.appointment = true;
            this.vShow.approval = true;
            this.vShow.apply_for_final_approval_upload = true
            if(this.getDetailNCE().attachment.waiting_for_diversion !== undefined){
                this.vShow.diversion = true;
            }
        } else if( this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_FINAL ) {
            this.vShow.briefing_session = true;
            this.vShow.appointment = true;
            this.vShow.apply_for_final_approval_upload = true
            if(this.getDetailNCE().attachment.waiting_for_diversion !== undefined){
                this.vShow.diversion = true;
            }
            
            if(this.getDetailNCE().attachment.approval !== undefined && this.getDetailNCE().attachment.approval.length > 0){
                this.vShow.approval = true;
            }
        } else if(this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.CANCELLED){
            this.vShow.cancelled_attachment = true;
            this.vShow.appointment = true;
            this.vShow.briefing_session = true;
        } else if(this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPLY_FINAL_APPROVAL || 
        this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.INSPECTION_FINAL_APPROVAL || 
        this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPLY_FINAL_APPROVAL_REJECTED) {
            this.vShow.apply_for_final_approval_upload = true;
            this.vShow.briefing_session = true;
            this.vShow.appointment = true;
        }

        if(this.actionChecking('APPNCE', access)){ // NCEA
            this.vShow.btn_back = true;
            this.vShow.btn_cancel_nce = true;
            if (
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPROVED ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.CANCELLED ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPLICATION_EXPIRED ||                
                this.getDetailNCE().status_description == STATIC_VALUE.ALL_NCE_STATUS.EXPIRED
            ){
                this.vShow.btn_cancel_nce = false;
            }
            if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_PROVISIONING){
                this.vShow.btn_approve = true;
                this.vShow.btn_change_appointment = true;
                this.vShow.upload_document = true;
                this.vShow.payment = true;
            } else if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_TRIAL_HOLE_INSPECTION){
                this.vShow.btn_approve = true;
                this.vShow.btn_reject = true;
                this.vShow.btn_waiting_diversion = true;
                this.vShow.btn_change_appointment = true;
                this.vShow.upload_document = true;
                this.vShow.payment = true;
            } else if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.INSPECTION_FINAL_APPROVAL){
                this.vShow.btn_approve = true;
                this.vShow.btn_reject = true;
                this.vShow.payment = true;
                this.vShow.upload_document = true;
            } else if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.WAIT_DIVERSION){
                this.vShow.btn_approve = true;
                this.vShow.btn_reject = true;
                this.vShow.upload_document = true;
                this.vShow.payment = true;
            } else if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_FINAL){
                this.vShow.btn_approve = true;
                this.vShow.btn_reject = true;
                this.vShow.upload_document = true;
                this.vShow.payment = true;
            } else if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_BRIEFING_DOCUMENT){
                this.vShow.btn_approve = true;
                this.vShow.btn_reject = true;
                this.vShow.payment = true;
                if(this.isExtensionNCE()){
                    this.vShow.upload_document = true;
                    this.vShow.btn_approve = true;
                    this.vShow.btn_reject = true;
                }                
            }else if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_DOCUMENT){
                this.vShow.btn_approve = true;
                this.vShow.btn_reject = true;
                this.vShow.payment = true;
            } else if (
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED_BRIEFING_DOCUMENT ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED_APPOINTMENT_DOCUMENT ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.EXPIRED ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPOINTMENT_DOCUMENT_UPLOAD ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_SCHEDULE ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_BRIEFING_SCHEDULE
            ) {
                this.vShow.payment = true;
            }
            
            if(
                (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_BRIEFING_SCHEDULE ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_PROVISIONING ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_SCHEDULE ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_BRIEFING_DOCUMENT ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_DOCUMENT ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPOINTMENT_DOCUMENT_UPLOAD ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED_BRIEFING_DOCUMENT ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED_APPOINTMENT_DOCUMENT ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPLY_FINAL_APPROVAL ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.INSPECTION_FINAL_APPROVAL ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPLY_FINAL_APPROVAL_REJECTED)
                && (new Date(this.getDetailNCE().create_date) < new Date('2019-06-01')) // For Production Environment
                && !this.isExtensionNCE()
            ) {
                this.vShow.btn_special_reject = true;
            }

        } else if(this.actionChecking('MANNCE', access)){ // NCE Ops
            this.vShow.btn_back = true;
        } else if(this.actionChecking('PURNCE', access)){ // Customer
            if(this.getDetailNCE().status_description === 'NCE_XX'){
                // this.vShow.contractor_details = false;
                this.vShow.btn_back = true;
                this.vShow.btn_payment = true;
            } else if(this._layoutService.getCurrentPage() === 'nce-view'){
                this.vShow.btn_back = true;
                if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_BRIEFING_SCHEDULE){
                    this.vShow.btn_briefing_session = true;
                } else if (this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_SCHEDULE ){
                    this.vShow.btn_make_appointment = true;
                } else if(this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPOINTMENT_DOCUMENT_UPLOAD){
                    this.vShow.btn_upload_appointment_upload = true;
                } else if(this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPLY_FINAL_APPROVAL || 
                    this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPLY_FINAL_APPROVAL_REJECTED){
                    this.vShow.btn_upload_apply_for_final_approval_upload = true;
                }
            } else if(this._layoutService.getCurrentPage() === 'nce-final-approval' && this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPROVED){
                this.vShow.btn_home = true;
            } else if(this._layoutService.getCurrentPage() === 'nce-briefing-document'){
                this.vShow.btn_back = true;
            }
        }
        return this.vShow;
    }

    isShowEditButton(){
        let access;
        this.resetShowState();
        try{
            access = JSON.parse(this._storageService.getLocalItem('access'));
        }catch(e){
            access = null;
        }
        if(this.actionChecking('PURNCE', access)){ 
            if(
                // this.getDetailNCE().status_description == this.getAllNCEStatus().PENDING_BRIEFING_DOCUMENT || 
                // this.getDetailNCE().status_description == this.getAllNCEStatus().PENDING_APPOINTMENT_DOCUMENT  ||
                this.getDetailNCE().status_description == this.getAllNCEStatus().REJECTED_BRIEFING_DOCUMENT ||
                this.getDetailNCE().status_description == this.getAllNCEStatus().REJECTED_APPOINTMENT_DOCUMENT
            ){
                return true
            }else{
                return false
            }
        }else{
            return false
        }
    }

    isShowEditAllButton(){
        let access;
        this.resetShowState();
        try{
            access = JSON.parse(this._storageService.getLocalItem('access'));
        }catch(e){
            access = null;
        }

        if(this.actionChecking('APPNCE', access)){ 
            return true
        }else{
            return false
        }
    }

    actionChecking(type, accesses) {
        for(var access of accesses){
            if(access == type){
                return true;
            }
        }
        return false;
    }

    getAllNCEStatus(){
        return STATIC_VALUE.ALL_NCE_STATUS;
    }

    setCurrentFlow(){
        if(this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_TRIAL_HOLE_INSPECTION ||
            this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.WAIT_DIVERSION ||
            this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_SCHEDULE){
            this._layoutService.setNCEFlow('nce-make-appointment');
        }else if(
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_FINAL ||
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED ||                
                this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPROVED){
                this._layoutService.setNCEFlow('nce-final-approval');
        } else if(this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_BRIEFING_SCHEDULE) {
            this._layoutService.setNCEFlow('nce-briefing-session');
        } 
    }

    vListFiles = [];

    fileEvent(fileInput: any){
        let file = fileInput.target.files[0];
        if(file === undefined){
            return;
        }
        if(file.size > CONFIGURATION.FILE.MAX_SIZE) {
            this._popupService.openGeneralConfirmationPopup('Notice', 'Attached file type size must be less than 10MB', '', false, false);
            return;
        }
        if(this.vListFiles.some(x => x.name === file.name)){
            this._popupService.openGeneralConfirmationPopup('Notice', 'Please provide file with another name', '', false, false);
            return;
        }
        this.vListFiles.push(file);
        this.vFileInput.nativeElement.value = "";
    }

    vCancellationFiles = [];
    vNCERejectionFiles = [];

    fileCancellationEvent(vFileCancellation: any){
        let file = vFileCancellation.target.files[0];
        if(file === undefined){
            return;
        }
        if(file.size > CONFIGURATION.FILE.MAX_SIZE) {
            this._popupService.openGeneralConfirmationPopup('Notice', 'Attached file type size must be less than 10MB', '', false, false);
            return;
        }
        if(this.vCancellationFiles.some(x => x.name === file.name)){
            this._popupService.openGeneralConfirmationPopup('Notice', 'Please provide file with another name', '', false, false);
            return;
        }
        this.vCancellationFiles.push(file);
        this.vFileCancellation.nativeElement.value = "";
    }

    fileNCERejectionEvent(vFileNCERejection: any){
        let file = vFileNCERejection.target.files[0];
        if(file === undefined){
            return;
        }
        if(file.size > CONFIGURATION.FILE.MAX_SIZE) {
            this._popupService.openGeneralConfirmationPopup('Notice', 'Attached file type size must be less than 10MB', '', false, false);
            return;
        }
        if(this.vCancellationFiles.some(x => x.name === file.name)){
            this._popupService.openGeneralConfirmationPopup('Notice', 'Please provide file with another name', '', false, false);
            return;
        }
        this.vNCERejectionFiles.push(file);
        this.vFileNCERejection.nativeElement.value = "";
    }

    updateStatusCustomer(){
        let pStatus = '';
        if(this.getDetailNCE().status_description === this.getAllNCEStatus().REJECTED_BRIEFING_DOCUMENT){
            pStatus = this.getAllNCEStatus().PENDING_BRIEFING_DOCUMENT;
        }else{
            pStatus = this.getAllNCEStatus().PENDING_APPOINTMENT_DOCUMENT;
        }
        this._nceService.updateStatus(this._nceService.getNCEID().nce_record_id, pStatus).then(
            (resolve) => {
                this._nceService.loadDetailNCE(this._nceService.getNCEID().nce_record_id).then(
                    (resolve) => {
                        this._popupService.openGeneralConfirmationPopup('Notice', 'NCE has been successfully set to waiting for document approval', '', true, false);
                        this.isEditMode = false;
                        this.setCurrentFlow();
                    },
                    (reject) => {
                        
                    }
                );
            },
            (reject) => {
                
            }
        );
    }

    updateStatus(pStatus, pAttachType, pMessage, pIsRejection){
        /*for(let file of this.vListFiles){
            this._fileService.getSignedRequest(file, 'nce', 'approval', this._nceService.getNCEID().nce_request_id, this._nceService.getNCEID().nce_record_id);
        }*/
        let cancellationFiles = false;
        let diversionRemarks = false;
        
        if(pAttachType == 'cancellation'){
            cancellationFiles = true;
        } else if (pAttachType == 'approval'){
            diversionRemarks = true;
        }
        this._fileService.sequentialMultipleUpload(this.vNCERejectionFiles.length > 0 ? this.vNCERejectionFiles : cancellationFiles? this.vCancellationFiles : this.vListFiles,'nce', pAttachType, this._nceService.getNCEID().nce_request_id, this._nceService.getNCEID().nce_record_id).then(
            (resolve) => {
                cancellationFiles? this.vCancellationFiles = [] : this.vListFiles = [];
                this._nceAdminService.updateStatus(this.nceid, pStatus, pIsRejection, 
                    pIsRejection ? this.nceRejectionRemarks ? this.nceRejectionRemarks : cancellationFiles ? this.cancelationRemarks : diversionRemarks ? this.waitDiversionRemarks : this.remarks : '').then(
                    (resolve) => {
                        this._nceService.loadAdminDetailNCE(this.nceid).then(
                            (resolve) => {
                                if(pIsRejection === true) {
                                    this._popupService.openGeneralConfirmationPopup('Notice', 'An document rejection email has been sent to this contractor', '', true, false);
                                } else if(pMessage === 'briefing'){
                                    this._popupService.openGeneralConfirmationPopup('Notice', 'NCE Briefing Session has been successfully approved', '', true, false);
                                } else {
                                    this._popupService.openGeneralConfirmationPopup('Notice', 'NCE has been successfully set to ' + pMessage, '', true, false);
                                }
                                this.setCurrentFlow();
                            },
                            (reject) => {
                                
                            }
                        );
                    },
                    (reject) => {
                        this._nceService.loadAdminDetailNCE(this.nceid)
                    }
                );
            },
            (reject) => {
                
            }
        )  
    }

    openStatusConfirmationPopup(pStatus: string, pAttachType: string, pMessage: string, pIsRejection?: boolean){
        this._popupService.openPopup( 'confirmation', {
            title: 'Notice',
            message: 'Are you sure?',
            buttons: {
                CANCEL: {
                    text: 'No',
                    function: () => {
                        this._popupService.closeConfirmationPopup();
                    }
                },
                OK: {
                    text: 'Yes',
                    function: () => {
                        this.updateStatus(pStatus, pAttachType, pMessage, pIsRejection || false);
                        this._popupService.closeConfirmationPopup();
                    }
                }
            }}
        );
    }

    openStatusConfirmationPopupPendingDiversion(pStatus: string, pAttachType: string, pMessage: string, pIsRejection?: boolean){
        let rephrasedMessage = 'Are you sure to set this NCE to Pending Diversion Review and send email to ';
        if(this.getDetailNCE().contract_principal == 'LTA')
            rephrasedMessage = rephrasedMessage + "xxxxxx@Netlink.com";//Kowsalya
        else if(this.getDetailNCE().contract_principal == 'PUB')
            rephrasedMessage = rephrasedMessage + "xxxxxx@Netlink.com";//Kowsalya
        else
            rephrasedMessage = rephrasedMessage + "xxxxxx@Netlink.com";//Kowsalya
        rephrasedMessage = rephrasedMessage + "?";

        this._popupService.openPopup( 'confirmation', {
            title: 'Notice',
            message: rephrasedMessage,
            buttons: {
                CANCEL: {
                    text: 'No',
                    function: () => {
                        this._popupService.closeConfirmationPopup();
                    }
                },
                OK: {
                    text: 'Yes',
                    function: () => {
                        this.updateStatus(pStatus, pAttachType, pMessage, pIsRejection || false);
                        this._popupService.closeConfirmationPopup();
                    }
                }
            }}
        );
    }

    openChangeAppointment(pAppointmentType){
        this.vLoadingShow = true;
        this._nceService.loadAppointmentAvaibility().then(
            (resolve) => {
                this._nceService.loadAvailableTime(new Date(this.getDetailNCE().appointment_date), pAppointmentType).then(
                    (resolve) => {
                        this.vAppointmentData = {
                            updated_date : new Date(this._nceService.getAppointmentAvaibility().updated_date),
                            appointment_date: new Date(this.getDetailNCE().appointment_date),
                            appointment_time: this.getDetailNCE().appointment_time,
                            appointment_description: this.getDetailNCE().appointment_description,
                            appointment_type: this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_PROVISIONING ? 'briefing' : 'appointment',
                            popup_title: this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_PROVISIONING ? 'Change Briefing' : 'Change Appointment'
                        }
                        this.openChangeAppointmentPopup(pAppointmentType);
                    },
                    (reject) => {
                        
                    }
                );
            },
            (reject) => {

            }
        );
    }

    openChangeAppointmentPopup(pAppointmentType){
        this._popupService.openPopup( 'change-appointment', {
            title: 'Change ' + pAppointmentType,
            message: '',
        }
        );
    }

    goToMakeAppointment(){
        let vLink = ['nce-application/make-appointment'];
        this._pageNavigationService.navigate(vLink);
    }

    goToBriefingSession(){
        let vLink = ['nce-application/briefing-session'];
        this._pageNavigationService.navigate(vLink);
    }

    goToUploadAppointmentDocument() {
        let vLink = ['nce-application/appointment-upload'];
        this._pageNavigationService.navigate(vLink);
    }

    goToUploadFinalApprovalApplicationDocument() {
        let vLink = ['nce-application/apply-for-final-approval'];
        this._pageNavigationService.navigate(vLink);
    }

    goToEditPreview() {
        let vLink = ['nce-application/edit-preview'];
        this._pageNavigationService.navigate(vLink);
    }

    generateCSV() {
        if(this.vLoadingShow){
            return;
        };

        this.vLoadingShow = true;
        let nce_record_id = this.getDetailNCE().nce_record_id ? this.getDetailNCE().nce_record_id : this._nceService.getNCEID().nce_record_id;

        this._nceAdminService.getDetailLinkCSV(nce_record_id).then(
            (resolve) => {
                console.log("initiate download", resolve.toString());
                const xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.onload = (event) => {
                    /* Create a new Blob object using the response
                    *  data of the onload object.
                    */
                    const blob = new Blob([xhr.response], { type: 'application/pdf' });
                    const a: any = document.createElement('a');
                    a.style = 'display: none';
                    document.body.appendChild(a);
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = 'nce_detail.pdf';
                    a.click();
                    window.URL.revokeObjectURL(url);
                    this.vLoadingShow = false;
                };
                xhr.open('GET', resolve.toString());
                xhr.send();               
            },
            (reject) => {
                this.vLoadingShow = false;
            }
        );
    }

    goBack(){
        let vLink;
        if(this._layoutService.getCurrentPage() === 'nce-preview'){
            vLink = ['nce-application/declaration'];
        } else if(this._layoutService.getCurrentPage() === 'nce-view'){
            vLink = ['customer-history'];
        } else if(this._layoutService.getCurrentPage() === 'nce-admin-request'){
            vLink = ['nce-application/all'];
        }

        else if(this._layoutService.getCurrentPage() === 'nce-briefing-document'){
            vLink = ['customer-history'];
        }

        this._pageNavigationService.navigate(vLink);
    }

    goHome(){
        let vLink = ['home'];
        this._pageNavigationService.navigate(vLink);
    }

    goToPayment(){
        let vLink = ['nce-application/payment'];
        this._pageNavigationService.navigate(vLink);
    }

    // downloadFile(file:string,attachType) {
    //     this.vLoadingShow = true;
    //     this._fileService.getSignedDownloadRequest(file,'nce',attachType,this.getDetailNCE().prev_request_id);
    // }
    downloadFile(file:string,attachType) {
        if(file) {
            this.vLoadingShow = true;
            if(this.getNceAttachment().newplantmap && this.getNceAttachment().newplantmap.length >= 1) {
                this._fileService.getSignedDownloadRequest(file,'nce',attachType,this.getDetailNCE().nce_request_id);
            } else {
                this._fileService.getSignedDownloadRequest(file,'nce',attachType,this.getDetailNCE().prev_request_id);
            }       
        }
    }

    removeAttachment(pIndex){
        this.vListFiles.splice(pIndex, 1);
    }

    removeCancellationAttachment(pIndex){
        this.vCancellationFiles.splice(pIndex, 1);
    }

    removeNCERejectionAttachment(pIndex){
        this.vNCERejectionFiles.splice(pIndex, 1);
    }

    getNatureOfProposedRemark(){
        if(this.getDetailNCE().earthwork_remark !== undefined || this.getDetailNCE().nature_proposed_earthwork !== undefined){
            let text = this.getDetailNCE().earthwork_remark + ', ' + this.getDetailNCE().nature_proposed_earthwork;
            return text
        }
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/components/preview/preview-child.component.ts